import React,{useState,useEffect} from 'react'
import qs from 'qs';
import {useHistory} from "react-router-dom";
import axios from 'axios';
import {TextField,Stack ,MenuItem,FormControl,Select,InputLabel,
  Box, IconButton }from '@material-ui/core';
 
import Modal from '../Generales/ModalTam';
import {llamadaApiToken,ErrorGeneral,llamaApiCargaToken } from '../funciones/ClienteAxios';
import {printConsole} from '../funciones/ConsolaLog'
import moment from 'moment';
import {toast} from 'react-toastify';
import CircularProgress from '@material-ui/core/CircularProgress';
import {Search as SearchIcon} from '@material-ui/icons/';
const NvoEditSeguro = ({modalAbierto, setModalAbierto, registro,Buscar}) => {
  const Dispvo =localStorage.getItem('Dispvo') ;    
  const auxDispV =Dispvo.length >= 12 ? Dispvo:'451224452121'  
  const history = useHistory();
  const usuId =localStorage.getItem('UsuId') ; 
  const hoy=moment(new Date()).format('YYYY-MM-DD')
  const source = axios.CancelToken.source();            
  const [espera,setEspera]= useState(false);
  const [listTipo,setListTipo]= useState([])  
  const [aviso,setAviso]= useState(false)  
  const [listAseguradora,setListAseguradora]= useState([])  
  const [btnDeshabilitado,setBtnDeshabilitado]= useState(true)  
 
  const [contadorToast,setContadorToast]= useState(0)  
  const [seguro,setSeguro]= useState({Tipo:'',
    FIni:hoy, FFin:hoy, 
    Representa:'', Descripcion:'',  Aseguradora:"", Nota:"", Poliza:""})
  const{Tipo,  FIni, FFin,  Representa, Descripcion,  
    Aseguradora, Nota, Poliza  }=seguro
  
  useEffect(() => {    
    getListTipo()
    getListAseguradora()
    if (registro.length!==0) {
      const auxIni=moment.utc( registro.FIni).format('YYYY-MM-DD')
      const auxFin=moment.utc( registro.FFin).format('YYYY-MM-DD')
      setSeguro({...seguro, Tipo: registro.TpId, Poliza:registro.Poliza,
        Descripcion: registro.Descr, Aseguradora:registro.AsegId, Nota:registro.Notas,
        FIni:auxIni, FFin:auxFin,
      })
    }
    return () => {
      source.cancel();
    }

  }, [])
  
  const getListTipo = () => {    
    const data = qs.stringify({
        Usuario:usuId,                
        idDispositivo: auxDispV
    });
    const url = "/maquinaria/seguro/tipo";

    function respuesta(auxiliar) 
    { 
        if (auxiliar[0].Id !== -1) 
        {                 
          setListTipo(auxiliar)
        }
    }
    llamadaApiToken(data, url, respuesta, ErrorGeneral,  history, source);
  };

  const getListAseguradora = () => {    
    const data = qs.stringify({
        Usuario:usuId,                
        idDispositivo: auxDispV
    });
    const url = "/maquinaria/seguro/aseguradora";

    function respuesta(auxiliar) 
    { 
        if (auxiliar[0].Id !== -1) 
        {                 
          setListAseguradora(auxiliar)
        }
    }
    llamadaApiToken(data, url, respuesta, ErrorGeneral,  history, source);
  };

  const llamadaApi = () => {                       
    const data = qs.stringify({
        Usuario:usuId, 
        Llave:registro.length!==0 ? registro.Id : 0,
        Tipo:Tipo, 
        Aseguradora:Aseguradora,        
        Status:1,
        Descr:Descripcion,
        Nota:Nota,
        Poliza:Poliza,
        FIni:`${FIni}T00:00:00`,
        FFin:`${FFin}T23:59:59`,
        //FFirma:`${FFirma}:00`,
  
        idDispositivo: auxDispV,
    });
    
    const url = "/maquinaria/seguro/new-edit";
    function respuesta(auxiliar){            
      if ( auxiliar) 
      {                 
        Buscar()
        let mensaje=registro.length!==0 ? "Se edito correctamente el seguro":"Se creo correctamente el seguro"
        //setTipoAdvertencia("success")      
        //setMensaje(mensaje);
        //setAviso(true)     
        toast.success(`${mensaje}`,{
            pauseOnFocusLoss: false,
            theme: "colored",
            toastId: `exito-env`
        })  

        setModalAbierto(false)    
      }     
        
    }
    llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEspera, history, source);
  };  

  const onChangeDate=(e)=>{
    if (e.target.value!=="" && e.target.value!==null && e.target.value!==undefined 
      
    ) {
      if (e.target.value.length===10 && parseInt(e.target.value.substring(0,4 ))>=1900  ) 
      {
        if (e.target.name==="FIni" ) {
          setSeguro({...seguro,[e.target.name] : e.target.value,
            FFirma:e.target.value+"T09:00",
          })    
        }else{
          setSeguro({...seguro,[e.target.name] : e.target.value})  
        }
        
      }      
    } 
     
    printConsole(e.target.value)    
    printConsole(e.target.value.length)
  }

  const onChange=(e)=>{
    
    if (e.target.name==="Tipo") 
    {
      setSeguro({...seguro,[e.target.name] : e.target.value, })
     
    }
    else
    {
      setSeguro({...seguro,[e.target.name] : e.target.value})
    }
    
  }

  const selectTipo= <FormControl style={{   width: "10rem" ,marginRight:1+'rem'}} size="small">
    <InputLabel id="ipt-tipo">Tipo</InputLabel>
    <Select
      labelId="lbl-select-tipo" id="select-tipo" name="Tipo"
      value={Tipo} label="Tipo" onChange={onChange}
    >      
      {listTipo.map((tipo)=><MenuItem value={tipo.Id}>{tipo.Descr}</MenuItem>)}
    </Select>
  </FormControl>

  const selectAseguradora= <FormControl style={{  width: "17rem"}} size="small">
    <InputLabel id="ipt-aseguradora">Aseguradora</InputLabel>
    <Select
      labelId="lbl-select-aseguradora" id="select-aseguradora" name="Aseguradora"
      value={Aseguradora} label="Aseguradora" onChange={onChange}
    >      
      {listAseguradora.map((element)=><MenuItem value={element.Id}>{element.Descr}</MenuItem>)}
    </Select>
  </FormControl>

  const verificaNulos = (campo,descripcion)=>{
    let respuesta =false;               
    if( (typeof campo !== 'number' && typeof campo === 'string' 
        && (campo.trim() === '' || campo.trim() === null ))
        || campo === null
    ) 
    { let mensaje='No se lleno el campo '+descripcion      
      toast.warning(`${mensaje}`,{
        pauseOnFocusLoss: false, theme: "colored",
        toastId: `error-env ${contadorToast}`
      })  
      setContadorToast(contadorToast+1)
      respuesta =true
    }    
    return(respuesta);
  }

  const guardarDatos=()=>{    
    if( !verificaNulos(Tipo,"Tipo") && 
      (Tipo===1 && !verificaNulos(Aseguradora,"Aseguradora") || Tipo!==1 )  )      
    {      
      if (Poliza.length>=3 ||  !verificaNulos("","Poliza")) 
      {
        if (Descripcion.length>=3  ||  !verificaNulos("","Descripción")) 
        { 
          //console.log(Tipo);
          
          llamadaApi()
        }
      }
    }    
  }
  
 
  return (
  <Modal
    titulo={registro.length!==0 ? `Editar Seguro ${registro.Poliza}` :"Nuevo Seguro"} modalAbierto={modalAbierto}
    setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
    tamanio="md" btnDeshabilitado={false} cargando={espera}
    setCargando={setEspera} setAviso={setAviso}
  >
    <Box component="form"  style={{width:"28rem"}}>
      <Box mb={2}>
      {listTipo.length!==0 ? selectTipo : null}
      {listAseguradora.length!==0 ? selectAseguradora : null}
      </Box>
       
      <TextField
        label="Poliza" id="Poliza-campo"
        value={Poliza} name="Poliza" maxLength={50}
        size="small" style={{width:"28rem", marginBottom:"1rem"}} onChange={onChange}
      />  
      <Box >
      <TextField
        id="date-Ini" label="Fecha Inicio" type="date" size='small'
        value={FIni} style={{ width: 140,marginRight:.5+'rem' }} name="FIni"
        InputLabelProps={{ shrink: true }} onChange={onChangeDate}
      />
      <TextField
        id="date-Fin" label="Fecha Final" type="date" size='small'        
        value={FFin} style={{ width: 140 }} name="FFin"
        InputLabelProps={{ shrink: true }} onChange={onChangeDate}
      />
      </Box>
    {/*   <TextField
        id="datetime-Firma" label="Fecha Firma" size='small'
        type="datetime-local" name="FFirma" value={FFirma} 
        onChange={onChangeDate} style={{ width: 290 }} 
        InputLabelProps={{ shrink: true, }}
      /> */}
      <Box display={"flex"} flexDirection={"column"}>
        <TextField
          id="outlined-multiline-static" label="Descripción" variant='outlined'
          multiline rows={3} name="Descripcion" onChange={onChange}
          value={Descripcion} size='small' style={{marginRight:"1rem", marginTop:"1rem"}}
        />
        <TextField
          id="outlined-multiline-static" label="Nota" variant='outlined'
          multiline rows={3} name="Nota" onChange={onChange}
          value={Nota} size='small' style={{marginRight:"1rem", marginTop:"1rem"}}
        />
      </Box>
    </Box>
  </Modal>
  )
}

export default NvoEditSeguro